/* less/lib/less/tree/unicode-descriptor */ function _(require, module, exports) {
    var Node = require(232) /* ./node */;
    var UnicodeDescriptor = function (value) {
        this.value = value;
    };
    UnicodeDescriptor.prototype = new Node();
    UnicodeDescriptor.prototype.type = 'UnicodeDescriptor';
    module.exports = UnicodeDescriptor;
}
